import { Box, Stack } from "@mui/material";
import QueryPreservingLink from "../../../components/QueryPreservingLink";
import React, { useEffect, useRef } from "react";
import { useHits, useSearchBox } from "react-instantsearch";

const SearchResult = ({ hasFocus }) => {
  const { hits } = useHits();
  const { query } = useSearchBox();
  const resultsRef = useRef();

  useEffect(() => {
    if (query?.trim().length === 0 || !hits[0] || !hasFocus) {
      document.body.style.overflow = "auto";
    } else if (hits[0] && hasFocus) {
      document.body.style.overflow = "hidden";
    }

    return () => (document.body.style.overflow = "auto");
  }, [query, hits, hasFocus]);

  useEffect(() => {
    const showResults = hits[0] && hasFocus && query?.trim().length > 0;

    if (showResults) {
      const screenHeight = window.innerHeight;
      const elementTop = resultsRef?.current.getBoundingClientRect().top;
      const elementHeight = screenHeight - elementTop;

      resultsRef.current.style.height = elementHeight + "px";
    }
  }, [hits, hasFocus, query]);

  return (
    <Stack
      ref={resultsRef}
      sx={{
        backgroundColor: "white",
        overflowY: "scroll",
        position: "absolute",
        transform: "translate(-50%, 100%)",
        zIndex: 2,
        left: "50%",
        bottom: "0",
        width: "100vw",
        padding: "1em",
        paddingTop: "2em",
        fontSize: "18px",
        textDecoration: "none",
        display:
          hits[0] && hasFocus && query?.trim().length > 0 ? "flex" : "none",
        borderBottom: "1em solid white",
      }}
    >
      <Stack sx={{ maxWidth: "800px", alignSelf: "center" }}>
        {hits.map((hit) => (
          <Stack
            sx={{
              mb: "32px",
              flexShrink: 0,
            }}
            key={hit.slug}
          >
            <Box
              sx={{
                fontSize: "24px",
                marginBottom: "10px",
                fontWeight: "bold",
              }}
              dangerouslySetInnerHTML={{
                __html: hit?._highlightResult?.title?.value,
              }}
            />

            <Box
              sx={{}}
              dangerouslySetInnerHTML={{
                __html: hit?._snippetResult?.excerpt?.value,
              }}
            />

            <Box
              component={QueryPreservingLink}
              sx={{
                color: "#6a27e8",
                marginTop: "6px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "16px",
                alignSelf: "start",
              }}
              to={`/blog/${hit.slug}`}
            >
              Read more
            </Box>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default SearchResult;
